import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

    constructor(private injector: Injector,
        private translate: TranslateService) {
    }

    handleError(error: any): string {
    if (!error) {
        return this.translate.instant('error.internalServerError');
    }

    const status = error.status ?? error.statusCode;

    if (status === 500) {
        console.error('Server error:', error);
        return this.translate.instant('error.internalServerError');
    }

    if (typeof error.message === 'string' && error.message.includes('Unknown')) {
        return this.translate.instant('error.network_unavailable');
    }

    const backendMessage = this.extractBackendMessage(error);
    if (backendMessage) {
        return backendMessage;
    }

    switch (status) {
        case 0:
            return this.translate.instant('error.network_unavailable');
        case 400:
            return this.translate.instant('error.something_incorrect');
        case 401:
            return this.translate.instant('error.unauthorized');
        case 403:
            return this.translate.instant('error.access_denied');
        case 404:
            return this.translate.instant('error.something_incorrect');
        case 409:
            return this.translate.instant('error.conflict');
        case 422:
            return this.translate.instant('error.validation_failed');
        case 429:
            return this.translate.instant('error.too_many_requests');
        case 502:
        case 503:
        case 504:
            return this.translate.instant('error.service_unavailable');
        default:
            return this.translate.instant('error.internalServerError');
    }
}

    private extractBackendMessage(error: any): string | null {
    const body = error.error;

    if (!body) {
        return null;
    }

    if (typeof body === 'object') {
        if (typeof body.detail === 'string') {
            return body.detail;
        }
        if (typeof body.message === 'string') {
            return body.message;
        }
    }

    if (typeof body === 'string') {
        try {
            const parsed = JSON.parse(body);
            return parsed?.detail ?? parsed?.message ?? null;
        } catch {
            return null;
        }
    }

    return null;
}
}
